import { render } from "./OnboardingPasswordInput.vue?vue&type=template&id=6a4b4602&scoped=true"
import script from "./OnboardingPasswordInput.vue?vue&type=script&lang=js"
export * from "./OnboardingPasswordInput.vue?vue&type=script&lang=js"

import "./OnboardingPasswordInput.vue?vue&type=style&index=0&id=6a4b4602&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a4b4602"]])

export default __exports__